import { useTranslation } from "react-i18next";
import { PageHeader } from "@velocity-ehs/component-library";
import VerticalTabs from "../../../sharedComponents/VerticalTabs";
import { useForm } from "react-hook-form";
import { useHistory } from "react-router-dom";
import { PersonUserForm } from "./PersonUserForm";
import { IPersonUserForm } from "../Person";
import useUserMutation, {
  UserActions,
} from "../../../../hooks/useUserMutations";

const AddPersonUser = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const formMethods = useForm<IPersonUserForm>({
    mode: "onBlur",
    defaultValues: {
      displayName: "",
      email: "",
      firstName: "",
      lastName: "",
      username: "",
      relationshipToCustomer: null,
    },
  });

  const { mutations } = useUserMutation();

  const handleCreateUser = (values: IPersonUserForm) => {
    return mutations.mutate(UserActions.CREATE, values).then((user) => {
      history.push(`/person/${user.person.id}/edit`);
    });
  };

  return (
    <>
      <PageHeader
        title={t("action_add_user")}
        navigationTree={[
          { text: `Accelerate ${t("universal_Home")}`, href: "/" },
          { text: t("universal_persons_users"), href: "/persons" },
          { text: t("universal_Add"), href: "" },
        ]}
        secondaryButton={{
          label: t("universal_Cancel"),
          id: "cancel",
          type: "button",
          onClick: () => history.push("/persons"),
        }}
        primaryButton={{
          label: t("universal_Save"),
          type: "submit",
          id: "personUserForm",
          form: "personUserForm",
          loading: formMethods.formState.isSubmitting,
        }}
      />
      <VerticalTabs
        tabs={[
          {
            content: (
              <>
                <PersonUserForm
                  formMethods={formMethods}
                  onSubmit={handleCreateUser}
                />
              </>
            ),
            title: t("action_add_user"),
          },
        ]}
      />
    </>
  );
};

export default AddPersonUser;
